import React, { useState, useEffect } from 'react';
import TaskerResumeModal from 'react-scale/corp/components/Lookup/sections/TaskerResumeModal';
import { IUserJson } from '@scale/shared/types/user';
import { Icon } from '@scale/scaleui';
import { logResumeSearchEvent } from './api';
import { ResumeSearchEventType } from '@scale/shared-types';
import { useMutation } from 'react-query';
import { useUser } from 'react-scale/components/ui/UserContext';

type ViewResumeButtonProps = {
  user: { _id: string; firstName: string; lastName: string };
};
export const ViewResumeButton = ({ user }: ViewResumeButtonProps) => {
  const requestingUser = useUser();
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [resumeResponse, setResumeResponse] = useState<{
    resume?: string;
    resumeNotFound: boolean;
  }>({
    resume: undefined,
    resumeNotFound: false,
  });

  useEffect(() => setResumeResponse({ resume: undefined, resumeNotFound: false }), [user]);

  const { mutate: logEvent } = useMutation(
    async () =>
      await logResumeSearchEvent({
        type: ResumeSearchEventType.View,
        userId: requestingUser.id,
        data: { resumeOwner: user._id },
      }),
  );

  const onClick = () => {
    logEvent();
    setShowResumeModal(true);
  };

  return (
    <>
      <Icon
        icon={['fas', 'eye']}
        onClick={onClick}
        rounded
        tooltip="View"
        size="sm"
        variant="neutral"
      />
      <TaskerResumeModal
        isModalOpen={showResumeModal}
        hideModal={() => setShowResumeModal(false)}
        resume={resumeResponse.resume}
        setResumeResponse={setResumeResponse}
        user={user as IUserJson}
      />
    </>
  );
};
